<template>
	<div class="transfer-machine">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('transferMachine.title')"
			:visible.sync="dialogTransferMachine"
			width="50%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<el-form
				label-position="top"
				:rules="rules"
				ref="machine"
				label-width="80px"
				:model="machine">
				<el-row>
					<div style="display: flex; justify-content: flex-end">
						<el-link
							@click="handlerQuicklyCreateAccount"
							type="primary"
							:underline="false"
							>{{ $t("transferMachine.quicklyCreateAccount") }}</el-link
						>
					</div>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('transferMachine.uId')" prop="uId">
							<el-select
								v-model="machine.uId"
								:no-data-text="$t('common.noData')"
								:no-match-text="$t('common.noData')"
								filterable
								remote
								clearable
								:remote-method="remoteMethod"
								:loading="loadingUser"
								:placeholder="$t('transferMachine.pUserId')">
								<el-option
									v-for="item in userList"
									:key="item.id"
									:label="item.userName"
									:value="item.id">
									<span style="float: left">{{ item.userName }}</span>
									<span style="float: right; color: var(--vtm-ink-2); font-size: 13px">{{
										item.nickName
									}}</span>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('transferMachine.sell')" prop="sell">
							<el-select
								v-model="machine.sell"
								:no-data-text="$t('common.noData')"
								:no-match-text="$t('common.noData')"
								:placeholder="$t('transferMachine.pYesNo')"
								@change="sellChange">
								<el-option
									:label="$t('transferMachine.yes')"
									:value="1"></el-option>
								<el-option
									:label="$t('transferMachine.no')"
									:value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table
				v-loading="loading"
				:element-loading-text="$t('common.loading')"
				:data="machineList"
				height="400px"
				:empty-text="$t('transferMachine.emptyText')"
				style="width: 100%">
				<el-table-column
					prop="equipmentNo"
					:label="$t('transferMachine.equipmentNo')"></el-table-column>
				<el-table-column
					prop="typeName"
					:label="$t('transferMachine.typeName')"></el-table-column>
				<el-table-column
					prop="equipmentName"
					:label="$t('transferMachine.name')"></el-table-column>
				<el-table-column
					prop="apkVersion"
					:label="$t('transferMachine.appVersionName')"
					width="150"></el-table-column>
				<el-table-column :label="$t('transferMachine.sell')" width="150">
					<template slot-scope="scope">
						<span
							class="vtm-pill"
							:class="scope.row.sell === 0 ? 'vtm-pill--off' : 'vtm-pill--ok'"
							>{{
								scope.row.sell === 0
									? $t("transferMachine.no")
									: $t("transferMachine.yes")
							}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="machineList.length <= 0"
					@click="transferMachine('machine')"
					>{{ $t("transferMachine.transfer") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "TransferMachine",
	props: {
		teamId: String,
		dialogTransferMachine: Boolean,
	},
	data() {
		return {
			value: "",
			machineList: [],
			loading: false,
			userList: [],
			machine: {
				uId: "",
				sell: 0,
			},
			loadingUser: false,
			rules: {
				uId: [
					{
						required: true,
						message: this.$t("transferMachine.pUserId"),
						trigger: "change",
					},
				],
			},
		};
	},
	methods: {
		handlerQuicklyCreateAccount() {
			this.$emit("quicklyCreateAccount");
		},
		openDialog() {
			this.listMachine();
		},
		listMachine() {
			this.loadingUser = true;
			let obj = { sell: this.machine.sell, teamId: this.teamId };
			this.$api
				.request(this.$url.Machine.machineList, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.machineList = res.data;
					}
					this.loadingUser = false;
				})
				.catch(() => {
					this.loadingUser = false;
				});
		},
		closeDialog() {
			this.cancel("");
			this.clearValidate("machine");
			this.machine.sell = 0;
		},
		sellChange() {
			this.listMachine();
		},
		cancel(state) {
			this.$emit("cancelTransferMachine", false, state);
		},
		transferMachine(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let obj = { uId: this.machine.uId, teamId: this.teamId };
					this.$api
						.request(this.$url.MachineGroup.moveGroup, this.$method.post, obj)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
							}
							this.cancel("");
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
						});
				}
			});
		},
		remoteMethod(val) {
			if (val !== "") {
				this.$api
					.request(this.$url.User.listUserByUsername, this.$method.get, {
						userName: val,
					})
					.then(res => {
						if (res.code === 0) {
							this.userList = res.data;
						}
					});
			}
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		appType(row) {
			return this.$cloud.getDictLabel(this.appTypeList, row.appType);
		},
	},
};
</script>

<style scoped></style>
